import React from "react";
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

// let TEForm = localStorage.getItem("TEFormApplicable");

class SubBannerStaff extends React.Component {
    render() {
        const { TEForm } = this.props;
        return (
            <div>
                <div className="sub-banner" style={{ width: "100%", zIndex: '1' }}>
                    {TEForm && TEForm === true ?
                        <div className="row w-100">

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()} >
                                    <NavLink strict to={`/Home/Ship/Staff/Tasks`} activeClassName="active-link-submenu">
                                        <h2>Ship's Pending Tasks</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/MaintenanceRevision`} activeClassName="active-link-submenu">
                                        <h2>IHM Maintenance Revision</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/Certificates`} activeClassName="active-link-submenu">
                                        <h2>Certificates & Documents</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => {
                                    this.hideEditPODetailPanel();
                                    this.props.dispatch({
                                        type: "MaterialValidationSearch",
                                        data: null
                                    });
                                }}>
                                    <NavLink exact to={`/Home/Ship/Staff/MaterialValidation`} activeClassName="active-link-submenu">
                                        <h2>PO Hazardous Material Validation</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/ShipDocument`} activeClassName="active-link-submenu">
                                        <h2>IHM Reference Documents</h2>
                                    </NavLink>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/TEForms`} activeClassName="active-link-submenu">
                                        <h2>TE Forms</h2>
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                        :
                        <div className="row w-100">

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()} >
                                    <NavLink strict to={`/Home/Ship/Staff/Tasks`} activeClassName="active-link-submenu">
                                        <h2>Ship's Pending Tasks</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/MaintenanceRevision`} activeClassName="active-link-submenu">
                                        <h2>IHM Maintenance Revision</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/Certificates`} activeClassName="active-link-submenu">
                                        <h2>Certificates & Documents</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="page-head-submenu p-1" onClick={() => {
                                    this.hideEditPODetailPanel(); this.props.dispatch({
                                        type: "MaterialValidationSearch",
                                        data: null
                                    });
                                }}>
                                    <NavLink exact to={`/Home/Ship/Staff/MaterialValidation`} activeClassName="active-link-submenu">
                                        <h2>PO Hazardous Material Validation</h2>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-2">
                                <div className="page-head-submenu p-1" onClick={() => this.hideEditPODetailPanel()}>
                                    <NavLink exact to={`/Home/Ship/Staff/ShipDocument`} activeClassName="active-link-submenu">
                                        <h2>IHM Reference Documents</h2>
                                    </NavLink>
                                </div>
                            </div>
                            {/* <div className="col-sm-12">
                            <ul id="nav">
                                <li>
                                    <div className="page-head-submenu" onClick={() => this.hideEditPODetailPanel()} >
                                        <NavLink strict to={`/Home/Ship/Staff/Tasks`} activeClassName="active-link-submenu">
                                            <h2>My Pending Tasks</h2>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="page-head-submenu" onClick={() => this.hideEditPODetailPanel()}>
                                        <NavLink exact to={`/Home/Ship/Staff/MaintenanceRevision`} activeClassName="active-link-submenu">
                                            <h2>IHM Maintenance Revision</h2>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="page-head-submenu" onClick={() => this.hideEditPODetailPanel()}>
                                        <NavLink exact to={`/Home/Ship/Staff/Certificates`} activeClassName="active-link-submenu">
                                            <h2>Certificates</h2>
                                        </NavLink>
                                    </div>
                                </li>
                                <li>
                                    <div className="page-head-submenu" onClick={() => this.hideEditPODetailPanel()}>
                                        <NavLink exact to={`/Home/Ship/Staff/MaterialValidation`} activeClassName="active-link-submenu">
                                            <h2>PO Hazardess Material Validation</h2>
                                        </NavLink>
                                    </div>
                                </li>
                            </ul>
                        </div> */}
                        </div>
                    }

                </div>
            </div>
        )
    }

    hideEditPODetailPanel = () => {
        this.props.dispatch({ type: "ShowStaffPendingTaskPanel", data: false });
    }
}

function mapStateToProps(state) {
    return {
        shipId: state.ShipViewReducer.ShipId || null,
        TEForm: state.ShipViewReducer.TEForm,
    }
}

export default connect(mapStateToProps, null)(SubBannerStaff);